<template>
  <div class="text-gray-dark">
    <SectionTitle v-model="show">
      {{ venue.influencer_reviews.length }} influencer reviews
    </SectionTitle>

    <div v-if="show" class="influencers-carousel">
      <CarouselType1 :slides-to-show="3" :slides-to-scroll="3">
        <div v-for="review in venue.influencer_reviews" :key="review.id" class="relative px-3">
          <a :href="review.url" target="_blank" rel="nofollow noopener" class="relative mb-3 block overflow-hidden rounded pb-[177.8%]">
            <div class="absolute flex size-full justify-center bg-gray-400 bg-cover align-middle">
              <picture>
                <source v-if="review.video_thumbnail_webp" :srcset="review.video_thumbnail_webp" type="image/webp">
                <source :srcset="review.video_thumbnail" type="image/jpeg">
                <img
                  draggable="false"
                  class="absolute left-0 size-full object-cover"
                  :src="review.video_thumbnail"
                  :alt="review.platform"
                  loading="lazy"
                >
              </picture>
            </div>
            <div class="absolute left-0 top-3.5 bg-white px-2 text-sm font-medium text-black">
              {{ review.platform }}
            </div>
          </a>

          <div class="overflow-hidden whitespace-nowrap font-medium">
            @{{ review.influencer_name }}
          </div>
          <div>
            <span v-if="review.posted_at">{{ $f.fromNow(review.posted_at) }}</span>
            <span v-if="review.posted_at && review.views_count"> • </span>
            <span v-if="review.views_count">{{ $f.largeNum(review.views_count) }} views</span>
          </div>
        </div>
      </CarouselType1>
    </div>
  </div>
</template>

<script>
import SectionTitle from '~/components/venue/SectionTitle'
import CarouselType1 from '~/components/shared/CarouselType1'

export default {
  components: { CarouselType1, SectionTitle },

  props: {
    venue: { type: Object, required: true },
  },

  data: () => ({
    show: true,
  }),
}
</script>

<style scoped lang="scss">
@media (min-width: 912px) {
  .influencers-carousel { max-width: 672px; }
}
:deep() {
  .slick-prev, .slick-next { top: calc(50% - 60px); }
}
</style>
